<div class="w100 pos-fix vh-center text-center">
  <input class="mx-auto w60 mB20" placeholder="Paste session token here" [(ngModel)]="sessionToken" />
  <div class="w50 m-auto">
  <button class="primary w100" (click)="addSessionTokenToCookie()">
    Login
  </button>
  </div>
</div>